import React, { useState } from "react";
import { useSettings, useLang } from "../lib/providers";
import { ChevronDown } from "lucide-react";

export default function FAQ() {
  const { settings } = useSettings();
  const { lang } = useLang();
  const [open, setOpen] = useState(0);
  if (!settings?.faq_enabled) return null;
  const items = settings.faq_items || [];
  if (items.length === 0) return null;
  const title = lang === "ar" ? (settings.faq_title_ar || settings.faq_title_fr) : (settings.faq_title_fr || settings.faq_title_ar);

  return (
    <section id="faq" className="py-16 sm:py-20 theme-section scroll-mt-24" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <h2 className="font-heading font-black uppercase tracking-tighter text-4xl sm:text-5xl leading-[0.9] mb-8">{title}</h2>
        <div className="space-y-2">
          {items.map((it, i) => {
            const q = lang === "ar" ? (it.q_ar || it.q_fr) : (it.q_fr || it.q_ar);
            const a = lang === "ar" ? (it.a_ar || it.a_fr) : (it.a_fr || it.a_ar);
            const isOpen = open === i;
            return (
              <div key={i} className="border border-white/10 bg-black/30 overflow-hidden" data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full text-left px-4 py-3 flex items-center justify-between gap-3 hover:bg-white/5 transition-colors"
                  data-testid={`faq-q-${i}`}
                >
                  <span className="font-bold text-sm sm:text-base">{q}</span>
                  <ChevronDown className={`w-4 h-4 transition-transform shrink-0 ${isOpen ? "rotate-180 text-neon" : "text-white/40"}`} />
                </button>
                {isOpen && (
                  <div className="px-4 pb-4 text-sm text-white/70 leading-relaxed border-t border-white/5 pt-3" data-testid={`faq-a-${i}`}>
                    {a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
